module.exports = __webpack_public_path__ + "static/media/TUSA-aboutus-corevalues-hero-mobile.0ea747e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TUSA-aboutus-corevalues-hero-mobile.jpg
// module id = 299
// module chunks = 0